// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Implantacao_DadosFranquiaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** POST /implantacao/dados_franquia — o franqueado grava os dados da própria unidade (rascunho aceito). */
import { registerContract } from './validate'

export interface Implantacao_DadosFranquiaInput {
franquia_id?: number
nome_fantasia?: string
cnpj?: string
inscricao_estadual?: string
telefone?: string
cep?: string
endereco?: string
numero?: string
complemento?: string
bairro?: string
cidade?: string
estado?: string
}

registerContract('Implantacao_DadosFranquiaInput', {
  franquia_id:        { type: 'number',  required: false },
  nome_fantasia:      { type: 'string',  required: false },
  cnpj:               { type: 'string',  required: false },
  inscricao_estadual: { type: 'string',  required: false },
  telefone:           { type: 'string',  required: false },
  cep:                { type: 'string',  required: false },
  endereco:           { type: 'string',  required: false },
  numero:             { type: 'string',  required: false },
  complemento:        { type: 'string',  required: false },
  bairro:             { type: 'string',  required: false },
  cidade:             { type: 'string',  required: false },
  estado:             { type: 'string',  required: false },
})
